import * as Sentry from '@sentry/react';

import {
  createSentryMetrics,
  normalizeMetricKey,
} from '../../../api/src/shared/metrics/sentry-metrics-core';

export type { MetricAttributes } from '../../../api/src/shared/metrics/sentry-metrics-core';

const { trackCount, trackDuration } = createSentryMetrics(Sentry);

export { normalizeMetricKey, trackCount, trackDuration };
